/* global angular */

// General
import alerts from './alertsCtrl';
import attachmentsTable from './tables/attachments';
import firmInviteAlert from './alertsCtrl/alerts/firmInvite';
import productAlert from './alertsCtrl/alerts/product';
import componentHandler from './componentHandler';
import errorComponent from './error';
import loading from './loading';
import sponsors from './sponsors';
import event from './event';
import eventEvaluation from './eventEvaluation';
import course from './course';
import bundle from './bundle';
import bundleInfo from './bundleInfo';
import courseEvaluation from './courseEvaluation';
import marketplace from './marketplace';
import marketplaceAdminReg from './marketplaceAdminReg';
import marketplaceBundle from './marketplaceBundle';
import marketplaceCalendar from './marketplaceCalendar';
import marketplaceCards from './marketplaceCards';
import marketplaceFilter from './marketplaceFilter';
import marketplaceButton from './marketplaceButton';
import marketplaceTable from './marketplaceTable';
import cpeCatalog from './cpeCatalog/base';
import cpeCatalogCards from './cpeCatalog/cards';
import cpeCatalogFilter from './cpeCatalog/filter';
import cpeCatalogTable from './cpeCatalog/table';
import cpeCatalogCalendar from './cpeCatalog/calendar';
import miscFiles from './miscFiles';
import toggle from './toggle';
import generateReports from './generateReports';
import jotForm from './jotForm';

import activityInfo from './activities/activityInformation';
import activityUsers from './activities/activityUsers';
import activitiesTable from './activities/activitiesTable';
import activityCards from './activities/activityCards';

// self-study
import selfStudyNav from './selfStudy/nav';
import selfStudyTopNav from './selfStudy/topNav';
import selfStudyFinal from './selfStudy/final';
import selfStudyVideo from './selfStudy/video';
import selfStudyQuiz from './selfStudy/quiz';
import selfStudyProgress from './selfStudy/progress';
// Forms
import csvParse from './forms/csvParse';
import validateRegistration from './forms/validateRegistration';
import multiAnswer from './forms/multiAnswer/input';
import multiAnswerView from './forms/multiAnswer/view';
import paragraphResponses from './forms/paragraphResponses/input';
import paragraphResponsesView from './forms/paragraphResponses/view';
import ratings from './forms/ratings/input';
import ratingsView from './forms/ratings/view';
import singleLineResponses from './forms/singleLineResponses/input';
import singleLineResponsesView from './forms/singleLineResponses/view';
import specialTopicsDropdown from './forms/specialTopicsDropdown';
import fileUpload from './forms/fileUpload';
import optionSelect from './forms/optionSelect';
import optionSelectSearch from './forms/optionSelectSearch';
import questionTypeOrder from './forms/questionTypeOrder';
import tags from './forms/tags';
import tagsSelect from './tagsSelect';
// User
import addCert from './users/addCert';
import complianceTracker from './users/complianceTracker';
import complianceTrackerGauges from './users/complianceTrackerGauges';
import hours from './forms/hours';
import advancedOptions from './forms/advancedOptions';
import incompleteEvaluations from './users/incompleteEvaluations';
import latestCourseActivity from './users/latestCourseActivity';
import upcomingEvents from './users/upcomingEvents';
import upcomingInvitations from './users/upcomingInvitations';
import complianceOverview from './users/complianceOverview';
import detailedComplianceBreakdown from './users/detailedComplianceBreakdown';
import profile from './users/profile';
import progressActivities from './users/progressActivities';
import progressAssignedActivities from './users/progressAssignedActivities';
import progressAssignedCourses from './users/progressAssignedCourses';
import progressCourses from './users/progressCourses';
import progressEvents from './users/progressEvents';
import progressTracks from './users/progressTracks';
import progressUserTracks from './users/progressUserTracks';
import pdfPreview from './pdfPreview';
import userProfile from './users/userProfile';
import noContent from './noContent';
// Tables
import eventBasicTable from './tables/eventsBasic';
import reportCertificateTable from './report/reportsCertificateTable';
import trackCourseStatusTable from './tables/trackCourseStatus';
import usersBasicTable from './tables/usersBasic';
// Author V2 TOP
import customTable from './customTable';
import donutChart from './donutChart';
import dualListBox from './forms/dualListBox';
import infiniteScroll from './infiniteScroll';
import licenseCategoryFilter from './licenseCategoryFilter/index.js';
import reportNav from './report/reportNav';
import reportTopNav from './report/reportTopNav';
// Author V2 BOTTOM
import authorFinalQuestions from './author/finalQuestions';
import authorInfo from './author/info';
import authorMaterial from './author/materials';
import authorModules from './author/modules';
import authorSubmitForReview from './author/submitForReview';
import expirationDateEditor from './author/expirationDateEditor';

import progressTile from './progressTIle';

import sideNav from './sideNav';

import reportsRenewals from './users/reports/renewals/index.js';
// Admin
import signInSheet from './admin/eventManager/event/signInSheet';
import userSearch from './usersSearch';
import locationEditor from './admin/eventManager/event/locationEditor';
import priceEditor from './admin/eventManager/event/priceEditor';
import webinarEditor from './admin/eventManager/event/webinarEditor';
import externalEditor from './admin/eventManager/event/externalEditor';
import eventExternal from './admin/eventManager/event/eventExternal';

import conferenceEditor from './admin/eventManager/event/conferenceEditor';
import blendedEditor from './admin/eventManager/event/blendedEditor';

import instructorEditor from './admin/eventManager/event/instructorEditor';
import notificationsEditor from './admin/eventManager/event/notificationsEditor';

import dateEditor from './admin/eventManager/event/dateEditor';
import locationSelector from './admin/eventManager/event/locationSelector';
import courseAccessEditor from './admin/eventManager/event/courseAccessEditor';
import eventOverviewEditor from './admin/eventManager/event/eventOverviewEditor';
import createEvent from './admin/eventManager/event/createEvent';
import invitees from './admin/eventManager/event/invitees';
import usersSelect from './admin/eventManager/event/usersSelect';
import registrations from './admin/eventManager/event/registrations';
import waitlist from './admin/eventManager/event/waitlist';
import webinarRegistrations from './admin/eventManager/event/webinarRegistrations';
import addCertificates from './admin/eventManager/event/addCertificates';
import eventsEventExternalAttendees from './admin/eventManager/external/attendees';
import eventsEventExternalCertificates from './admin/eventManager/external/certificates';
import eventsEventExternalEdit from './admin/eventManager/external/edit';
import eventsEventIssueCertificates from './admin/eventManager/event/issueCertificates';
import eventsEventIssueCertificatesExternals from './admin/eventManager/event/issueCertificatesExternals';

import eventsEventIssueInstructorCertificates from './admin/eventManager/event/issueInstructorCertificates';
//Event Manager Views
import eventManagerInfo from './admin/eventManager/event/info';
import eventManagerAddons from './admin/eventManager/event/addons';
import eventManagerNavigation from './admin/eventManager/event/navigation';
import eventManagerAlerts from './admin/eventManager/event/alerts';
import eventManagerMaterials from './admin/eventManager/event/materials';
import eventManagerInvitations from './admin/eventManager/event/invitations';
import eventManagerRegistrationsView from './admin/eventManager/event/registrationsView';
import eventManagerCertificates from './admin/eventManager/event/certificates';
import eventManagerReports from './admin/eventManager/event/reports';
import eventManagerEvaluations from './admin/eventManager/event/evaluations';
import eventManagerEmails from './admin/eventManager/event/emails';
import eventManagerEmail from './admin/eventManager/event/email';
import emailEventInfoOptions from './admin/eventManager/event/emailEventInfoOptions';
import goToWebinarSelect from './admin/eventManager/event/goToWebinarSelect';

import eventInfo from './eventInfo';
import eventSummary from './eventSummary';
import courseInfo from './courseInfo';
import courseProgress from './courseProgress';
import courseSummary from './courseSummary';

import cpeRequests from './cpeRequests';

export default angular
  .module('app.components', [])
  .component('activityInfo', activityInfo)
  .component('activityUsers', activityUsers)
  .component('activityCards', activityCards)
  .component('activitiesTable', activitiesTable)
  .component('addCert', addCert)
  .component('advancedOptions', advancedOptions)
  .component('alerts', alerts)
  .component('attachmentsTable', attachmentsTable)
  .component('bundle', bundle)
  .component('bundleInfo', bundleInfo)
  .component('firmInviteAlert', firmInviteAlert)
  .component('productAlert', productAlert)
  .component('locationEditor', locationEditor)
  .component('instructorEditor', instructorEditor)
  .component('notificationsEditor', notificationsEditor)
  .component('dateEditor', dateEditor)
  .component('courseAccessEditor', courseAccessEditor)
  .component('eventOverviewEditor', eventOverviewEditor)
  .component('addCertificates', addCertificates)
  .component('eventBasicTable', eventBasicTable)
  .component('trackCourseStatusTable', trackCourseStatusTable)
  .component('usersBasicTable', usersBasicTable)
  .component('eventsEventExternalAttendees', eventsEventExternalAttendees)
  .component('eventsEventExternalEdit', eventsEventExternalEdit)
  .component('eventsEventExternalCertificates', eventsEventExternalCertificates)
  .component('eventsEventIssueCertificates', eventsEventIssueCertificates)
  .component('eventsEventIssueCertificatesExternals', eventsEventIssueCertificatesExternals)
  .component('eventsEventIssueInstructorCertificates', eventsEventIssueInstructorCertificates)
  .component('createEvent', createEvent)
  .component('eventInfo', eventInfo)
  .component('eventSummary', eventSummary)
  .component('complianceOverview', complianceOverview)
  .component('complianceTracker', complianceTracker)
  .component('complianceTrackerGauges', complianceTrackerGauges)
  .component('componentHandler', componentHandler)
  .component('customTable', customTable)
  .component('detailedComplianceBreakdown', detailedComplianceBreakdown)
  .component('donutChart', donutChart)
  .component('progressTile', progressTile)
  .component('dualListBox', dualListBox)
  .component('error', errorComponent)
  .component('csvParse', csvParse)
  .component('validateRegistration', validateRegistration)
  .component('fileUpload', fileUpload)
  .component('optionSelect', optionSelect)
  .component('optionSelectSearch', optionSelectSearch)
  .component('questionTypeOrder', questionTypeOrder)
  .component('tags', tags)
  .component('tagsSelect', tagsSelect)
  .component('hours', hours)
  .component('incompleteEvaluations', incompleteEvaluations)
  .component('infiniteScroll', infiniteScroll)
  .component('jotForm', jotForm)
  .component('licenseCategoryFilter', licenseCategoryFilter)
  .component('latestCourseActivity', latestCourseActivity)
  .component('loading', loading)
  .component('paragraphResponses', paragraphResponses)
  .component('paragraphResponsesView', paragraphResponsesView)
  .component('profile', profile)
  .component('progressActivities', progressActivities)
  .component('progressAssignedActivities', progressAssignedActivities)
  .component('progressAssignedCourses', progressAssignedCourses)
  .component('progressCourses', progressCourses)
  .component('progressEvents', progressEvents)
  .component('progressTracks', progressTracks)
  .component('progressUserTracks', progressUserTracks)
  .component('pdfPreview', pdfPreview)
  .component('miscFiles', miscFiles)
  .component('multiAnswer', multiAnswer)
  .component('multiAnswerView', multiAnswerView)
  .component('noContent', noContent)
  .component('ratings', ratings)
  .component('ratingsView', ratingsView)
  .component('reportNav', reportNav)
  .component('reportTopNav', reportTopNav)
  .component('reportCertificateTable', reportCertificateTable)
  .component('selfStudyNav', selfStudyNav)
  .component('selfStudyTopNav', selfStudyTopNav)
  .component('selfStudyFinal', selfStudyFinal)
  .component('selfStudyVideo', selfStudyVideo)
  .component('selfStudyQuiz', selfStudyQuiz)
  .component('signInSheet', signInSheet)
  .component('singleLineResponses', singleLineResponses)
  .component('singleLineResponsesView', singleLineResponsesView)
  .component('specialTopicsDropdown', specialTopicsDropdown)
  .component('selfStudyProgress', selfStudyProgress)
  .component('sponsors', sponsors)
  .component('toggle', toggle)
  .component('userSearch', userSearch)
  .component('upcomingEvents', upcomingEvents)
  .component('upcomingInvitations', upcomingInvitations)
  .component('marketplaceAdminReg', marketplaceAdminReg)
  .component('marketplaceButton', marketplaceButton)
  .component('event', event)
  .component('marketplaceBundle', marketplaceBundle)
  .component('marketplace', marketplace)
  .component('cpeCatalog', cpeCatalog)
  .component('cpeCatalogCards', cpeCatalogCards)
  .component('cpeCatalogFilter', cpeCatalogFilter)
  .component('cpeCatalogTable', cpeCatalogTable)
  .component('cpeCatalogCalendar', cpeCatalogCalendar)
  .component('marketplaceCalendar', marketplaceCalendar)
  .component('marketplaceCards', marketplaceCards)
  .component('marketplaceFilter', marketplaceFilter)
  .component('marketplaceTable', marketplaceTable)
  .component('userProfile', userProfile)
  .component('invitees', invitees)
  .component('usersSelect', usersSelect)
  .component('registrations', registrations)
  .component('locationSelector', locationSelector)
  .component('course', course)
  .component('courseInfo', courseInfo)
  .component('courseProgress', courseProgress)
  .component('courseSummary', courseSummary)
  .component('reportsRenewals', reportsRenewals)
  .component('sideNav', sideNav)
  .component('authorFinalQuestions', authorFinalQuestions)
  .component('authorInfo', authorInfo)
  .component('authorMaterial', authorMaterial)
  .component('authorModules', authorModules)
  .component('authorSubmitForReview', authorSubmitForReview)
  .component('expirationDateEditor', expirationDateEditor)
  .component('courseEvaluation', courseEvaluation)
  .component('emailEventInfoOptions', emailEventInfoOptions)
  .component('eventEvaluation', eventEvaluation)
  .component('eventManagerInfo', eventManagerInfo)
  .component('eventManagerAddons', eventManagerAddons)
  .component('eventManagerAlerts', eventManagerAlerts)
  .component('eventManagerNavigation', eventManagerNavigation)
  .component('eventManagerMaterials', eventManagerMaterials)
  .component('eventManagerInvitations', eventManagerInvitations)
  .component('eventManagerRegistrationsView', eventManagerRegistrationsView)
  .component('eventManagerCertificates', eventManagerCertificates)
  .component('eventManagerReports', eventManagerReports)
  .component('eventManagerEvaluations', eventManagerEvaluations)
  .component('eventManagerEmails', eventManagerEmails)
  .component('eventManagerEmail', eventManagerEmail)
  .component('waitlist', waitlist)
  .component('webinarRegistrations', webinarRegistrations)
  .component('webinarEditor', webinarEditor)
  .component('externalEditor', externalEditor)
  .component('eventExternal', eventExternal)
  .component('conferenceEditor', conferenceEditor)
  .component('priceEditor', priceEditor)
  .component('generateReports', generateReports)
  .component('goToWebinarSelect', goToWebinarSelect)
  .component('blendedEditor', blendedEditor)
  .component('cpeRequests', cpeRequests).name;



// WEBPACK FOOTER //
// ./src/app/components/index.js